import React from 'react';
import { Accordion, Modal } from 'react-bootstrap';
import * as Bs from 'react-icons/bs';

const initialState = {
  isShow: false,
};

const Tutorial = () => {
  const [{ isShow }, setState] = React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleClose = () => {
    clearState();
  };

  return (
    <>
      <div className="d-flex align-items-center py-2">
        <Bs.BsInfoCircleFill size={20} color="#2f83ba" className="me-2" />
        <span>
          Anda bisa menambahkan atau melihat detail pembayaran.
          <span
            className="fw-bold text-primary ms-1 text-decoration-underline cursor-pointer"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            Pelajari Invoice
          </span>
        </span>
      </div>

      <Modal show={isShow} onHide={$handleClose} centered size="md">
        <Modal.Header className="text-center d-block p-0" closeButton>
          <div className="py-3">
            <div className="fw-bold fs-6">Pelajari Invoice</div>
          </div>
        </Modal.Header>
        <Modal.Body className="px-2 py-3">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="pb-2">
                <div className="fs-6 fw-semibold">
                  Apa fungsi dari Invoice ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Invoice berfungsi untuk membuat faktur/tagihan pengiriman yang
                dlakukan kepada customer perusahaan.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Apa itu shipment belum dibayar ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Bagian tab Shipment belum Dibayar merupakan halaman yang
                menampilkan shipment/pengiriman yang telah selesai (sudah
                diterima/delivered) yang belum ditagihkan pembayarannya.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tutorial;
